<template>
  <div id="auth-bg" style="background-image: url(static/img/background/background-2.jpg)">
    <div id="login-container">
      <div class="block animation-fadeInQuickInv">
        <div class="login-header">
          <img
            src="/static/img/background/actslogo.png"
            alt="FOCUS Logo"
            class="login-logo"
          >
        </div>
        <div class="login-body">
          <div class="text-center">
            <div v-if="loading">
              <i class="fa fa-spinner fa-spin fa-3x" />
              <h6>{{ loadingMessage }}</h6>
            </div>
            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
              <p>
                <a href="/login" class="btn btn-primary">Back to Login</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authRepository from '../repositories/authRepository';

export default {
    name: 'MagicLinkCallback',
    data() {
        return {
            loading: true,
            loadingMessage: 'Verifying your login...',
            errorMessage: ''
        };
    },
    async mounted() {
        const { token } = this.$route.params;

        if (!token) {
            this.errorMessage = 'Invalid or missing token.';
            this.loading = false;
            return;
        }

        try {
            // Verify the magic link token and create session
            await authRepository.verifyMagicToken(token);

            // Success - redirect to main app
            this.$router.push('/main');
        } catch (error) {
            // Show error message
            const errorMsg = (error.response && error.response.data && error.response.data.message)
                || 'Unable to verify your login. Please try again.';
            this.errorMessage = errorMsg;
            this.loading = false;
        }
    }
};
</script>

<style scoped>
#auth-bg {
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  background-size: contain;
  background-position: right center;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

#login-container {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
}

.block {
  padding: 0;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
}

.animation-fadeInQuickInv {
  animation: fadeInQuick 0.3s ease-in;
}

@keyframes fadeInQuick {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  background: #0c3c61;
  padding: 28px 0 18px 0;
  text-align: center;
  border-radius: 10px 10px 0 0;
}

.login-logo {
  height: 48px;
  width: auto;
  filter: brightness(0) invert(1);
}

.login-body {
  padding: 32px 32px 24px 32px;
  background: #fff;
  border-radius: 0 0 10px 10px;
}

.text-center {
  text-align: center;
}

.alert {
  padding: 15px;
  border-radius: 5px;
  margin-top: 1rem;
}

.alert-danger {
  color: #b94a48;
  background: #f2dede;
  border: 1px solid #ebccd1;
}

.btn {
  display: inline-block;
  font-weight: 600;
  text-align: center;
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
  border-radius: 8px;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  text-decoration: none;
  margin-top: 1rem;
}

.btn-primary {
  background: #23486b;
  border: none;
  color: #fff;
}

.btn-primary:hover {
  background: #1a3650;
  text-decoration: none;
}

h3 {
  margin-top: 1rem;
  color: #333;
}
</style>
